import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PageNotFoundModule } from '@shared/lib/modules/page-not-found/page-not-found.module';
import { SharedModule } from '@shared/lib/shared.module';
import { SharedProviders } from '@shared/lib/shared.providers';
import { URL_SITE_DOMAIN } from '@usana/ux/common/url';
import {
  DYNATRACE_MANUAL_PAGE_DETECTION,
  DYNATRACE_WINDOW_OBJ_POLL_RATE,
  SsoDynatraceModule,
} from '@usana/ux/dynatrace';
import { I18nHonorCookie, I18nInfoConfig, I18nOrganization, MarketActiveStatus } from '@usana/ux/markets';
import { TranslationService } from '@usana/ux/translations';
import { environment } from '../environments/environment';
import { BaoyingFontAwesomeModule } from './baoying-font-awesome.module';
import { BaoyingRoutingModule } from './baoying-routing.module';
import { Locales, Markets } from './baoying.providers';
import { BaoyingAppComponent } from './components/app-root/baoying-app.component';
import { FooterCnComponent } from './components/footer-cn/footer-cn.component';
import { NewsListComponent } from './components/news-list/news-list.component';
import { OnlineConsultationComponent } from './components/online-consultation/online-consultation.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { BaoyingTranslationService } from './services/baoying-translation.service';

@NgModule({
  declarations: [
    BaoyingAppComponent,
    FooterCnComponent,
    NewsListComponent,
    OnlineConsultationComponent,
    PaginationComponent,
  ],
  imports: [
    BaoyingRoutingModule,
    BrowserModule,
    SharedModule,
    PageNotFoundModule,
    BaoyingFontAwesomeModule,
    SsoDynatraceModule,
  ],
  providers: [
    new SharedProviders(
      environment,
      Locales,
      Markets,
      'zhs-CN',
      () =>
        new I18nInfoConfig(
          false,
          false,
          true,
          false,
          true,
          false,
          false,
          false,
          MarketActiveStatus.ACTIVE,
          I18nOrganization.BAOYING,
          I18nHonorCookie.ALWAYS,
        ),
    ).providers.concat([
      { provide: TranslationService, useClass: BaoyingTranslationService },
      { provide: URL_SITE_DOMAIN, useValue: environment.siteDomain },
      { provide: DYNATRACE_WINDOW_OBJ_POLL_RATE, useValue: 1000 },
      { provide: DYNATRACE_MANUAL_PAGE_DETECTION, useValue: true },
    ]),
  ],
  bootstrap: [BaoyingAppComponent],
})
export class BaoyingModule {}
